module.exports = __webpack_public_path__ + "img/valores-pensar-e-agir.2ef4cb87.svg";